export class IContractData{  
    contract: string | undefined;
    contract_name: string | undefined;
    remediationraised:string | undefined;
    DoAccManage : string | undefined;
    ImpactedVersion:string | undefined;
    AppliedCorrAction : string | undefined;
    ClientAppExcep : string | undefined;
    ClientInf : string | undefined;
    ClientImp : string | undefined;
    CommentAct : any;
    MitigationComment : string| undefined;
    ContractVulStatus : string;
    chkList : number;
    FlagDelegate : number
  }